import styled from 'styled-components';

export const LeftSideBarBodyContainer = styled.div`
  display: grid;
  grid-gap: 32px;
  max-width: 347px;
`;

export const TitlesContainer = styled.div`
  display: grid;
  grid-gap: 8px;
`;

export const Title = styled.span`
  font-size: 28px;
  font-weight: 500;
  line-height: 36px;
  letter-spacing: 0em;
`;

export const SubTitle = styled.span`
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0em;
  text-align: left;
`;
